import {
  PopupDesc,
  PopupIconWrapper,
  PagePopupTitle,
} from 'components/Popup/ConfirmDialog/ConfirmDialog.styled';
import { CardHeader } from 'components/common';
import { PatientLayout } from 'containers/PatientLayout';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { PropsWithChildren, ReactNode } from 'react';
import { FaUserCheck } from 'react-icons/fa';
import { usePatientCheckIn } from '../../../context/patient/modules/checkIn';
import { PatientCheckInCard } from './PatientCheckIn.styled';
import { PageHelmet } from '../../../components/common/PageHelmet';

export type PatientCheckInLayoutProps = PropsWithChildren<{
  description?: {
    html: ReactNode;
    compact?: boolean;
  };
  label?: string;
  widerCard?: boolean;
}>;

export const PatientCheckInLayout = ({
  description,
  children,
  label,
  widerCard,
}: PatientCheckInLayoutProps) => {
  const { t } = useCommonTranslation();
  const {
    checkIn: { siteName },
  } = usePatientCheckIn();

  return (
    <PatientLayout graphics="patient">
      <PageHelmet title={t('check-in')} />
      <PatientCheckInCard
        style={
          widerCard
            ? {
                paddingLeft: 'var(--s3)',
                paddingRight: 'var(--s3)',
              }
            : {}
        }
      >
        <CardHeader>
          <PopupIconWrapper inlineIcon>
            <FaUserCheck />
          </PopupIconWrapper>
          <PagePopupTitle>
            {label
              ? label
              : siteName
              ? t('check-in-at-name', { siteName })
              : t('check-in-at')}
          </PagePopupTitle>
          {description && (
            <PopupDesc compact={description.compact}>
              {description.html}
            </PopupDesc>
          )}
        </CardHeader>
        {children}
      </PatientCheckInCard>
    </PatientLayout>
  );
};
